
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"margin":"auto"},style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","style":"margin:auto","width":"100","height":"100","preserveAspectRatio":"xMidYMid","display":"block"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(20 50)"}},[_c('circle',{attrs:{"r":"6","fill":"#576766","transform":"scale(.79529)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"-0.375s","calcMode":"spline","keySplines":"0.3 0 0.7 1;0.3 0 0.7 1","values":"0;1;0","keyTimes":"0;0.5;1","dur":"1s","repeatCount":"indefinite"}})])]),_c('g',{attrs:{"transform":"translate(40 50)"}},[_c('circle',{attrs:{"r":"6","fill":"#6c7b7a","transform":"scale(.9963)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"-0.25s","calcMode":"spline","keySplines":"0.3 0 0.7 1;0.3 0 0.7 1","values":"0;1;0","keyTimes":"0;0.5;1","dur":"1s","repeatCount":"indefinite"}})])]),_c('g',{attrs:{"transform":"translate(60 50)"}},[_c('circle',{attrs:{"r":"6","fill":"#c2d2d1","transform":"scale(.86855)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"-0.125s","calcMode":"spline","keySplines":"0.3 0 0.7 1;0.3 0 0.7 1","values":"0;1;0","keyTimes":"0;0.5;1","dur":"1s","repeatCount":"indefinite"}})])]),_c('g',{attrs:{"transform":"translate(80 50)"}},[_c('circle',{attrs:{"r":"6","fill":"#dee6e5","transform":"scale(.54615)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"scale","begin":"0s","calcMode":"spline","keySplines":"0.3 0 0.7 1;0.3 0 0.7 1","values":"0;1;0","keyTimes":"0;0.5;1","dur":"1s","repeatCount":"indefinite"}})])])])
          )
        }
      }
    